//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { useEffect } from 'react';
import { selectCurrentTableKey } from '../../redux/selectors/dataTableSelectors';
import { setCurrentTable } from '../../redux/slices/dataTableSlice';
import TableContainer from '../_common/Table/TableContainer';
import ProcessingTasksTitleBar from './ProcessingTasksTitleBar';
import useTaskDrawer from '../_hooks/useTaskDrawer';
import TaskDrawer from '../Tasks/TaskDrawer';
import DataTableFilters from '../_common/Filters/DataTableFilters';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

const ProcessingTasks = () => {
  const dispatch = useAppDispatch();
  const currentTableKey = useAppSelector(selectCurrentTableKey);
  const { activeTask, isDirty, fetchTask, onDrawerClose, onActiveTaskChange, setActiveTask, setIsDirty, taskLoading } = useTaskDrawer();

  useEffect(() => {
    dispatch(setCurrentTable('processingTasks'));
  }, []);

  return (
    <>
      {currentTableKey === 'processingTasks' && (
        <>
          <ProcessingTasksTitleBar />
          <DataTableFilters />
          {/* <ProcessingTasksFilters /> */}
          <TableContainer onRowClick={(e, item) => onActiveTaskChange(item)} />
          <TaskDrawer
            isDirty={isDirty}
            setIsDirty={setIsDirty}
            source="processing-exceptions"
            task={activeTask}
            onDrawerClose={onDrawerClose}
            onRefresh={fetchTask}
            loading={taskLoading}
            setActiveTask={setActiveTask}
          />
        </>
      )}
    </>
  );
};

export default ProcessingTasks;
